import pythonApiClient from './pythonBaseApi';

/**
 * Mantenimiento: comedor_lectores_offline (estaciones Electron)
 */
export const comedorLectoresOfflineApi = {
  getAll: (params = {}) => {
    const query = new URLSearchParams();
    if (params.id_proyecto) query.append('id_proyecto', params.id_proyecto);
    if (params.id_comedor) query.append('id_comedor', params.id_comedor);
    if (params.activo !== undefined && params.activo !== null) {
      query.append('activo', params.activo);
    }
    const qs = query.toString();
    return pythonApiClient.get(
      `/mantenimientos/comedor-lectores-offline${qs ? `?${qs}` : ''}`,
    );
  },

  getById: (id) => pythonApiClient.get(`/mantenimientos/comedor-lectores-offline/${id}`),

  create: (data) => pythonApiClient.post('/mantenimientos/comedor-lectores-offline', data),

  update: (id, data) =>
    pythonApiClient.put(`/mantenimientos/comedor-lectores-offline/${id}`, data),

  regenerarToken: (id) =>
    pythonApiClient.post(`/mantenimientos/comedor-lectores-offline/${id}/regenerar-token`),
};

export default comedorLectoresOfflineApi;
